/**
 * Приложенные файлы, о которых промпт молчит (владелец 25.09: «чем понятнее пилюли и чем
 * лучше научим ими пользоваться, тем лучше результат»). Разбор запусков Seedance показал:
 * когда промпт не ссылается на файл, модель сама решает, что с ним делать. Чип такого файла
 * подсвечивается, а ряд подсказывает вставить ссылку.
 *
 * Считаем только входы, у которых роль задаёт ссылка: референсы-фото (Image N), видео-,
 * аудио-референс и персонаж. Первый/последний кадр модель использует и без упоминания.
 */
import { assetIdOf, splitPromptByPhrases, tokenForPhrase, type PillToken } from '../prompt-vars/phrases'

// Ассет сцены (персонаж / локация / предмет) — тоже вход с ролью: без упоминания модель не знает, кто это.
const NEEDS_MENTION = new Set<PillToken['kind']>(['photo', 'video_ref', 'audio_ref', 'character', 'asset'])

const keyOf = (t: PillToken) => (t.kind === 'photo' ? `photo:${t.rank ?? 1}` : t.kind === 'asset' ? `asset:${t.assetId}` : t.kind)

/** Фраза чипа → пилюля: упоминание ассета (@{uuid}@) или каноническая фраза. */
const tokenOfPhrase = (phrase: string): PillToken | undefined => {
	const id = assetIdOf(phrase.trim())
	return id ? { phrase: phrase.trim(), kind: 'asset', assetId: id } : tokenForPhrase(phrase)
}

/** id чипов, чьи файлы приложены, но в промпте не упомянуты; пустой промпт — ничего не ругаем. */
export function unmentionedChipIds(
	prompt: string,
	chips: { id: string; url: string | null; phrase?: string }[],
): Set<string> {
	const out = new Set<string>()
	if (!prompt.trim()) return out
	const mentioned = new Set(
		splitPromptByPhrases(prompt)
			.filter((p) => p.type === 'pill' && p.token)
			.map((p) => keyOf(p.token!)),
	)
	for (const c of chips) {
		if (!c.url || !c.phrase) continue
		const tok = tokenOfPhrase(c.phrase)
		if (!tok || !NEEDS_MENTION.has(tok.kind)) continue
		if (!mentioned.has(keyOf(tok))) out.add(c.id)
	}
	return out
}
